export enum FiltersOrders {
    CREATION_DATE = 'CREATION_DATE',
    MODIFICATION_DATE = 'MODIFICATION_DATE',
    SENDING_DATE = 'SENDING_DATE',
    CREATOR = 'CREATOR',
    TITLE = 'TITLE'
}

export enum FiltersFilters {
    SHARED = 'SHARED',
    SENT = 'SENT',
    TO_DO = 'TO_DO',
    FINISHED = 'FINISHED'
}


// WEBPACK FOOTER //
// ./common/src/main/resources/ts/core/enums/formulaire-filters.ts